import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Research from '../../templates/Research'
import Loading from '../../atoms/Loading'

const GET_THEMES = gql`
  query Themes {
    themes(limit: 999, page: 1) {
      id
      name: nome
      url
    }
  }
`

const ResearchContainer = () => (
  <Query query={ GET_THEMES }>
    {({ loading, data }) => {
      if (loading) {
        return <Loading />
      }

      return (
        <Research
          {...this.props}
          themes={ data.themes }
        />
      )
    }}
  </Query>
)

export default ResearchContainer



// WEBPACK FOOTER //
// ./src/components/pages/Research/Research.container.js